import { useEffect } from 'react';
const LOCAL_STORAGE_PAGES_VISITED_KEY = 'sp_pages_visited';
const getParsedPageVisited = (localstoragePagesVisitedKey) => {
    const storedPagesAlreadyVisited = localStorage.getItem(localstoragePagesVisitedKey);
    try {
        if (storedPagesAlreadyVisited) {
            return JSON.parse(storedPagesAlreadyVisited);
        }
        return {};
    }
    catch (e) {
        return {};
    }
};
export const getPagesVisited = (lineOfBusiness) => {
    const parsedStoredPagesAlreadyViewed = getParsedPageVisited(LOCAL_STORAGE_PAGES_VISITED_KEY);
    if (parsedStoredPagesAlreadyViewed[lineOfBusiness]) {
        return parsedStoredPagesAlreadyViewed[lineOfBusiness];
    }
    return [];
};
export const usePagesVisited = (lineOfBusiness) => {
    useEffect(() => {
        const currentPageUrl = window.location.href;
        const parsedStoredPagesVisited = getParsedPageVisited(LOCAL_STORAGE_PAGES_VISITED_KEY);
        const newPagesVisited = parsedStoredPagesVisited[lineOfBusiness]
            ? Object.assign(Object.assign({}, parsedStoredPagesVisited), { [lineOfBusiness]: [
                    ...parsedStoredPagesVisited[lineOfBusiness],
                    currentPageUrl,
                ].slice(-10) }) : Object.assign(Object.assign({}, parsedStoredPagesVisited), { [lineOfBusiness]: [currentPageUrl] });
        localStorage.setItem(LOCAL_STORAGE_PAGES_VISITED_KEY, JSON.stringify(newPagesVisited));
    }, [lineOfBusiness]);
};
//# sourceMappingURL=usePagesVisited.js.map